module.exports = __webpack_public_path__ + "img/position.910901eb.png";